export const home = {
  hero: {
    title: 'Soluzioni di Hosting Professionali',
    subtitle: 'Server ad alte prestazioni, protezione DDoS e supporto esperto 24/7',
    cta: {
      primary: 'Inizia Ora',
      secondary: 'Vedi i Piani'
    }
  },
  features: {
    title: 'Perché Scegliere SynthoHosting',
    description: 'Scopri la nostra gamma di soluzioni hosting professionali',
    ddos: {
      title: 'Protezione DDoS Avanzata',
      description: 'Protezione fino a 4 Tbps per mantenere i tuoi servizi online'
    },
    network: {
      title: 'Rete ad Alta Velocità',
      description: 'Collegamenti multipli da 10G per prestazioni ottimali'
    },
    hardware: {
      title: 'Hardware Premium',
      description: 'Processori Intel e AMD di ultima generazione'
    }
  },
  about: {
    title: 'Chi Siamo',
    description: 'Soluzioni di hosting professionali con performance e affidabilità garantite',
    monitoring: {
      title: 'Monitoraggio 24/7',
      description: 'Monitoraggio continuo dell\'infrastruttura'
    },
    support: {
      title: 'Supporto Esperto',
      description: 'Team tecnico disponibile 24/7'
    },
    network: {
      title: 'Rete Ridondante',
      description: 'Collegamenti multipli da 10G'
    }
  }
};